// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"388":"7b6c2975","3243":"ea7c8c3d","8272":"9c64eff7"}[chunkId] + ".chunk.css";
};